import Image from 'next/image';
import React from 'react';

import { cx } from '@emotion/css';

import styles from './HeroView.module.scss';

export const HeroView = () => {
  return (
    <section className={styles.inner_hero}>
      <div className={styles.container}>
        <div className={styles.hero_inner_section}>
          <div className={styles.hero_banner}>
            <Image
              src="/images/propertyManager/hero/property-banner.png"
              width="1400"
              height="500"
              alt="hero image"
              className={cx(styles.manager_banner_img, styles.hero_banner_img)}
            />
          </div>
        </div>
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1440"
        height="330"
        viewBox="0 0 1440 330"
        fill="none"
        className={styles.wave}>
        <path
          d="M35.3062 7.02353C222.703 35.5011 379.545 107.712 504.816 145.343C837.574 244.209 1031.72 90.9463 1440 0C1440 732.212 1440 359.592 1440 882C960 882 721 882 3.01249e-06 882C2.89477e-06 393.018 -3.70741e-06 459.12 3.01408e-06 2.18378C11.7833 3.57537 23.5538 5.18743 35.3062 7.02353Z"
          fill="#FFFCFA"></path>
      </svg>
    </section>
  );
};
